<template>
  <v-list dense>
      <!-- v-model="settings" -->
    <v-list-item-group
      multiple
      active-class=""
    >
      <v-list-item
        v-for="(option, i) in options"
        :key="i"
        cols="1"
        class="pt-1 pb-2"
      >
        <div>
          <v-checkbox
            dense
            hide-details
            v-model="checked[i]"
            :label="$t(prefix + option)"
            @click="select"
          ></v-checkbox>
        </div>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<style scoped>
>>>.v-input--selection-controls {
  margin-top: 0;
}
</style>

<script>
export default {
  name: 'FormMultiple',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    checked: [],
  }),
  computed: {
    selected() {
      const sel = [];
      this.checked.forEach((val, i) => {
        if (val === true) {
          sel.push(this.options[i]);
        }
      });
      return sel;
    },
  },
  methods: {
    select() {
      this.$emit('select', this.selected);
    },
  },
};
</script>
